// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import components
import PageWrapper from "../../components/pageContentViews/pageWrapper";
import PageHeader from "../../components/pageContentViews/pageHeader";

// Import utils
import {mapStateToProps} from "../../redux/mapStateToProps";
import {deleteItem} from "../../utils/helperFunctions";
import {
    GetBanks,
    UpdateBankById,
    DeleteBankById,
    UpdateBanksPositions
} from "../../redux/actions";
import Nestable from "react-nestable";
import {NestableItem} from "../../components/cards/nestableItem";


class Banks extends Component {
    constructor(props){
        super(props);
        this.deleteBank = deleteItem.bind(this, props.DeleteBankById, 'բանկը');
        this.onPositionChange = this.onPositionChange.bind(this);
    }
    componentDidMount() {
        this.props.GetBanks();
    }

    getNestableItems(list, parent = null, mainLanguage){
        const items = [];
        list && !!list.length && list.forEach((item, index) => {
            const title = item?.translations?.find(tr => tr.language === mainLanguage)?.title || '';
            items.push({
                id: item.id,
                index: index,
                title: title,
                isHidden: item.isHidden,
                link: {
                    pathname: `banks/edit/${item.id}`,
                },
                deleteCb:  () => this.deleteBank(item.id),
            })
        });
        return items;
    }

    async onPositionChange(items, item){
        const movedItemId = item.id;

        const {banksList} = this.props;
        const positionedItems = items.map((item, index) => {
            return {id: item.id, position: index}
        });
        if (~banksList.findIndex(m => m.id === movedItemId) &&
            ~positionedItems.findIndex(m => m.id === movedItemId)) {
            // first level bank was re-positioned in first level
            await this.props.UpdateBanksPositions(positionedItems);
            this.props.GetBanks();
        }
    }

    render() {
        let {banksList, mainLanguage} = this.props;

        let items = this.getNestableItems(banksList, null, mainLanguage);
        return <PageWrapper pageTitle={'Բանկեր'}>
            <PageHeader linkTitle={"Ավելացնել"}
                        addingLink={"/banks/add"}/>
            {items && items.length !== 0 &&
            <Nestable
                items={items}
                maxDepth={1}
                onChange={this.onPositionChange}
                renderItem={NestableItem}
            />}
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetBanks,
    UpdateBankById,
    DeleteBankById,
    UpdateBanksPositions
};

export default connect(mapStateToProps, mapDispatchToProps)(Banks);
